import { render, staticRenderFns } from "./Members2026.vue?vue&type=template&id=a8c207f4&scoped=true"
import script from "./Members2026.vue?vue&type=script&lang=js"
export * from "./Members2026.vue?vue&type=script&lang=js"
import style0 from "./Members2026.vue?vue&type=style&index=0&id=a8c207f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c207f4",
  null
  
)

export default component.exports